module.exports = __webpack_public_path__ + "static/media/messenger.048fc6fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/messenger.svg
// module id = 221
// module chunks = 2